import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
    selector: 'app-dialogue-box',
    templateUrl: './dialogue-box.component.html',
    styleUrls: ['./dialogue-box.component.scss'],
    standalone: false
})
export class DialogueBoxComponent implements OnInit {
popupData: any;
  constructor(
    public dialogRef: MatDialogRef<DialogueBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogueBoxComponent,
  ) { }

  ngOnInit(): void {
    this.popupData = this.data;
  }

  close() {
    this.dialogRef.close(true);
  }
}
